// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-light[data-v-17b02c50]{background-color:#f8fafc}.border[data-v-17b02c50]{border:1px solid #e2e8f0}", ""]);
// Exports
module.exports = exports;
